import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./bookingDisplayItem.css";

const BookingDetailsItem = ({ iconname, itemText, label, bookingSummery }) => {
  return (
    <div className="flex items-center space-x-2 space-y-2 sm:space-y-0">
      <div
        className={`flex ${
          bookingSummery ? "space-x-2 sm:space-x-6" : "space-x-2"
        }  items-center sm:justify-end`}
      >
        <FontAwesomeIcon
          icon={iconname}
          className={`block text-slate-600  ${
            bookingSummery ? "text-xl w-4" : "text-sm"
          }`}
        />
        <div
          className={
            bookingSummery
              ? "text-[15px] w-24"
              : "text-xs text-secondary font-semibold"
          }
        >
          {label}:
        </div>
      </div>
      <div>
        <div
          className={` ${
            bookingSummery
              ? "text-[15px] text-gray-600 font-normal w-full myDIV "
              : "text-xs font-normal w-52 myDIV truncate "
          }  `}
        >
          {itemText}
        </div>

        {!bookingSummery && (
          <div className="text-sm font-semibold absolute hide ">
            <div className="bg-black opacity-60 rounded-md"></div>
            <div className="bg-black px-3 py-2 rounded-md z-20 relative mr-5">{itemText}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BookingDetailsItem;
